import React, { useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import { CarouselPumoModuleFragment } from '../../generated/types';
import { useUrlParams } from '../../hooks/useUrlParams';
import { LookTracking } from '../LookTracking';
import { SingleLooksModule } from './SingleLooksModule';

interface Props {
  carousels: CarouselPumoModuleFragment[];
}

const VIEW_THRESHOLD = 0.3;

export const LooksModule: React.FC<Props> = ({ carousels }) => {
  const {
    params: { look }
  } = useUrlParams();
  const { ref, inView } = useInView({ threshold: VIEW_THRESHOLD, triggerOnce: true });

  const lookIds = useMemo(
    () =>
      new Set(
        carousels.flatMap(({ cells }) =>
          cells.flatMap(cell => (cell.__typename === 'Look' ? [cell.id] : []))
        )
      ),
    [carousels]
  );

  return (
    <div ref={ref}>
      <LookTracking
        lookId={typeof look === 'string' && lookIds.has(look) ? look : undefined}
        lookSource="trunkshow_looks_module"
        tracksViews={inView}
      >
        {carousels.map(carouselPumoModule => (
          <SingleLooksModule key={carouselPumoModule.id} carousel={carouselPumoModule} />
        ))}
      </LookTracking>
    </div>
  );
};
